import React from 'react';
import { createDataParamForQuickLook, LeaderboardInfo } from './data';
import { QuickLook } from './quicklook';
import { QuickLookOptions } from './types';
import { DataRow, Params } from '../../types';

type LeaderboardQuickLookProps = {
  leaderboardData: LeaderboardInfo;
  quickLookOptions: QuickLookOptions;
  highlightedRow: DataRow;
  highlighted: string;
  paramsForData: Params;
  groupsParam: string;
  dataUrlRoot: string;
  componentSettings: Params;
  disabled: string[];
  quicklookIds: string[];
  setHighlighted: (value: React.SetStateAction<string>) => void;
  handleHighlight: (rowId: string) => void;
  updateSettings: (updates: Params) => void;
};

const LeaderboardQuickLook = ({
  leaderboardData,
  quickLookOptions,
  highlightedRow,
  highlighted,
  paramsForData,
  groupsParam,
  dataUrlRoot,
  componentSettings,
  disabled,
  quicklookIds,
  updateSettings,
  handleHighlight,
  setHighlighted,
}: LeaderboardQuickLookProps) => {
  if (!leaderboardData || !quickLookOptions || !highlightedRow) {
    return null;
  }

  return (
    <QuickLook
      options={quickLookOptions}
      row={highlightedRow}
      rowId={highlighted}
      ids={quicklookIds}
      onSelect={handleHighlight}
      onClose={() => setHighlighted(undefined)}
      paramsForData={createDataParamForQuickLook(paramsForData, groupsParam)}
      dataUrlRoot={dataUrlRoot}
      updateSettings={updateSettings}
      componentSettings={componentSettings}
      isDisabled={disabled.includes(highlighted)}
    />
  );
};

export { LeaderboardQuickLook };
